// supervisor-owned-checkout-recovery.ts
//
// "recover_owned_checkout" (architecture §6.1 else-branch, spec table row
// "Attempt": "Rollback về checkpoint trước attempt chỉ trên worktree sở
// hữu, sau khi hết writers; giữ runtime và ignored resources. Không git
// clean/reset mù checkout người."). Runs BETWEEN a rejected/failed attempt
// and the next physical run of the same ticket so a leftover uncommitted
// scope violation (or any other rejected diff) never silently becomes the
// NEXT attempt's baseline.
//
// Two operations, both scoped to the mission's OWN worktree (never the
// human's source checkout — that repo is never passed in here):
//   1. `git reset --hard HEAD` — discard tracked changes back to the last
//      commit-owner commit (subsumes a separate `git checkout -- .`, which
//      would be redundant after a hard reset).
//   2. `git clean -fd -e .avatar/attempt-output -e .avatar-session.lock*`
//      — remove untracked files EXCEPT the ignored runtime/staging
//      directories the spec says to keep.
//   3. `git clean -fdx -- .avatar/tickets` — security audit H-1 (c): an
//      ignored file in the controller's ticket directory is never a runtime
//      resource, only a ticket a worker hid from step 2.
import type { GitRunner } from "./commit-owner.js";

const KEEP_PATTERNS = [".avatar/attempt-output", ".avatar-session.lock*"];

async function run(gitRunner: GitRunner, args: string[], cwd: string): Promise<void> {
  const res = await gitRunner(args, cwd);
  if (res.status !== 0) {
    throw new Error(
      `supervisor-owned-checkout-recovery: git ${args.join(" ")} thất bại: ${res.stderr}`,
    );
  }
}

/**
 * Resets the mission worktree at `repoDir` back to HEAD, discarding any
 * uncommitted changes a rejected/failed attempt left behind — but keeping
 * ignored runtime resources (attempt-output staging, legacy lock files).
 */
export async function recoverOwnedCheckout(gitRunner: GitRunner, repoDir: string): Promise<void> {
  await run(gitRunner, ["reset", "--hard", "HEAD"], repoDir);
  const cleanArgs = ["clean", "-fd"];
  for (const pattern of KEEP_PATTERNS) cleanArgs.push("-e", pattern);
  await run(gitRunner, cleanArgs, repoDir);
  await run(gitRunner, ["clean", "-fdx", "--", ".avatar/tickets"], repoDir);
}
